import React, { useEffect, useState } from 'react';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GLOBAL_VARS, STATIC_LOOP_TIMERS } from '../../javascript/services/globalVars';
import style from './background-sound-indicator-style.module.scss';

function BackgroundSoundIndicator(Props) {
   let [color, setColor] = useState(() => 'red');
   useEffect(() => {
      STATIC_LOOP_TIMERS.background_sound_timer.start(() => {
         if (GLOBAL_VARS.background_sound_playing === true) {
            setColor('var(--green)');
         } else {
            setColor('red');
         }
      });
      return () => {
         STATIC_LOOP_TIMERS.background_sound_timer.stop();
      };
   }, []);
   return (
      <div className={style.wrap} style={{ color: color }} > <FontAwesomeIcon icon={faPlay} /> </div>
   );
}

export default BackgroundSoundIndicator;